import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

/**
 * Author Byline widget (section 3004). Presentation only — the author name and the
 * meta line both come from the page payload, so nothing about them is persisted here.
 */
export interface IAuthorBylinePayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  [key: string]: unknown;
}

export async function createAuthorByline(payload: IAuthorBylinePayload) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.AUTHOR_BYLINE.CREATE,
      payload,
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateAuthorByline(
  id: number,
  payload: IAuthorBylinePayload,
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.AUTHOR_BYLINE.UPDATE(id),
      payload,
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
